import { Box, Card, CardContent, Fade, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Modal, Select, Switch, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { post } from '../../utils/axios'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import { Context } from '../../context/Context'

const Send = () => {

    const navigate = useNavigate()
    const context = useContext(Context)
    const [isLoading,setIsLoading] = useState(false)
    const [isOtpLoading,setIsOtpLoading] = useState(false)
    const [acceptTerms,setAcceptTerms] = useState(false)
    const [openRules,setOpenRules] = useState(false)
    const [segments,setSegments] = useState([])
    const [selected,setSelected] = useState()
    const [rules,setRules] = useState('')
    const [sentOtp,setSentOtp] = useState(false)
    const [otpCounter,setOtpCounter] = useState('')
    const [otp,setOtp] = useState('')
    const [btnText,setBtnText] = useState('دریافت رمز')
    const [amount,setAmount] = useState('')

    useEffect(() => {
        axios.post('https://petromah.sabinarya.com/service/api/Info/GetTransferTypes').then(({ data }) => {
            if(data.status)
                setSegments([...data.result.filter(item => item.isActive)])
        })
    },[])
    
    useEffect(() => {
        if(selected){
            const segment = segments.find(s => s.id == selected)
            setRules(segment.description)
        }
    },[selected])

    useEffect(() => {
        if(otp && otp.length){
            if(otp.includes('۰'))
                setOtp(otp.replace(/۰/g,'0'))
            if(otp.includes('۱'))
                setOtp(otp.replace(/۱/g,'1'))
            if(otp.includes('۲'))
                setOtp(otp.replace(/۲/g,'2'))
            if(otp.includes('۳'))
                setOtp(otp.replace(/۳/g,'3'))
            if(otp.includes('۴'))
                setOtp(otp.replace(/۴/g,'4'))
            if(otp.includes('۵'))
                setOtp(otp.replace(/۵/g,'5'))
            if(otp.includes('۶'))
                setOtp(otp.replace(/۶/g,'6'))
            if(otp.includes('۷'))
                setOtp(otp.replace(/۷/g,'7'))
            if(otp.includes('۸'))
                setOtp(otp.replace(/۸/g,'8'))
            if(otp.includes('۹'))
                setOtp(otp.replace(/۹/g,'9'))
        }
    },[otp])

    const startCounter = () => {
        setOtpCounter(120)
        let interCounter = 120
        const interval = setInterval(() => {
            if(interCounter > 0){
                interCounter -= 1
                setOtpCounter(interCounter)
            }
            if(interCounter == 0){
                clearInterval(interval)
                setSentOtp(false)
            }
        },1000)
    }

    const onAmountChange = e => {
        const value = e.target.value.toString().replace(/,/g,'')
        setAmount(new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value))
    }

    const sendMoney = () => {
        setIsLoading(true)
        const segment = segments.find(s => s.id == selected)
        const postedData = {
            segmentSource: segment.source,
            segmentDestination: segment.destination,
            amount: parseInt(amount.toString().replace(/,/g,'')),
            otpCode: otp
        }
        post('Segment/TransferBetweenSegment',postedData).then(({ data }) => {
            if(data.isSuccess){
                toast.success('عملیات با موفقیت انجام شد')
                context.updateCardData()
                navigate(-1)
            }else
                toast.error(data.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const sendOtp = () => {
        setOtp('')
        setIsOtpLoading(true)
        setBtnText('دریافت مجدد رمز')
        const postedData = {
            otpCodeOperationType: 1
        }
        post('General/SendOtpCodeOperation',postedData).then(({ data }) => {
            setSentOtp(true)
            toast.success('رمز یکبار مصرف برای شما ارسال شد')
            startCounter()
        }).finally(() => {
            setIsOtpLoading(false)
        })
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">انتقال اعتبار</h3>
            <div className="safe-area">
                <Card sx={{mb: 5}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="segment-origin">مبدا و مقصد انتقال</InputLabel>
                                    <Select labelId="segment-origin" value={selected} label="مبدا و مقصد انتقال" onChange={e => setSelected(e.target.value)}>
                                        <MenuItem disabled>انتخاب کنید</MenuItem>
                                        {segments.map(segment => <MenuItem value={segment.id}>{`از ${segment.sourceTitle} به ${segment.destinationTitle}`}</MenuItem>)}
                                    </Select>
                                </FormControl>
                                <TextField label="مبلغ (ریال)" variant="standard" className="ltr-input" type="tel" fullWidth sx={{mt: 3,mb: 2.5}} onChange={onAmountChange} value={amount} />
                                <Grid container spacing={2}>
                                    <Grid item xs={7}>
                                        <TextField label="رمز یکبار مصرف" type="tel" className="ltr-input password-input" inputProps={{maxLength: 5}} variant="standard" fullWidth sx={{mb: 2.5,mt: 1}} onChange={e => setOtp(e.target.value)} value={otp} />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Button type="submit" isLoading={isOtpLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={sentOtp || !selected || !amount} onClick={sendOtp}>{sentOtp ? `${otpCounter} ثانیه` : btnText}</Button>
                                    </Grid>
                                </Grid>
                                {rules && <FormControlLabel sx={{mt: 1,mb: 2}} control={<Switch checked={acceptTerms} onChange={() => setAcceptTerms(!acceptTerms)} />} label={<p><span style={{ color: 'red' }} onClick={() => setOpenRules(true)}>قوانین و مقررات</span> انتقال را می پذیرم</p>} />}
                                <Modal open={openRules} onClose={() => setOpenRules(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                                    <Fade in={openRules}>
                                        <Box sx={style}>
                                            <Typography variant="h6" component="h2" sx={{ fontSize: 18,mb: 2 }}>قوانین و مقررات</Typography>
                                            <Typography variant="body2" textAlign="justify" lineHeight={2} component="p">{rules}</Typography>
                                            <Button type="submit" fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" onClick={() => {setOpenRules(false);setAcceptTerms(true)}}>متوجه شدم</Button>
                                        </Box>
                                    </Fade>
                                </Modal>
                                <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!selected || !amount || !acceptTerms || !sentOtp || !otp || otp.length != 5} onClick={sendMoney}>انتقال وجه</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default Send